import { useMutation } from '@urql/vue';

import type { CreateUserLearningCampaignEntryAction, UseCreateUserLearningCampaignEntry } from '~/types/Learn/learningCampaign';

import { createUserLearningCampaignEntryMutation, userLearningCampaignEntryFragment } from '~/graphql/documents/campaigns';
import { useFragment } from '~/graphql/generated';

export const useCreateUserLearningCampaignEntry = (): UseCreateUserLearningCampaignEntry => {
  const { t } = useI18n();
  const { executeMutation: createUserLearningCampaignEntry } = useMutation(createUserLearningCampaignEntryMutation);

  const createLearningCampaignEntry = async (learningCampaignId: string, skillAnswer?: string | null): Promise<CreateUserLearningCampaignEntryAction> => {
    const { data, error } = await createUserLearningCampaignEntry({
      input: { learningCampaignId, skillAnswer: skillAnswer || null },
    });

    if (error || !data?.createUserLearningCampaignEntry?.userLearningCampaignEntry) {
      const errorMessage = error ? getFirstErrorMessageFromCombinedErrors(t, error) : t('unified.errors.genericFailed');
      return { success: false, error: errorMessage };
    }

    const baseData = data.createUserLearningCampaignEntry.userLearningCampaignEntry;
    const entryData = useFragment(userLearningCampaignEntryFragment, baseData);

    return {
      data: {
        ...entryData,
        isUserEligible: baseData.learningCampaign?.isUserEligible ?? false,
        currentUserLearningCampaignEntries: baseData.learningCampaign?.currentUserLearningCampaignEntries?.map(entry => useFragment(userLearningCampaignEntryFragment, entry)) ?? [],
      },
      success: true,
    };
  };

  return { createLearningCampaignEntry };
};
